import {StyleSheet, ViewStyle} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  base: {
    width: '100%' as const,
    paddingHorizontal: indent * 0.8,
    paddingTop: indent * 0.8,
    paddingBottom: 0,
  } as ViewStyle,
  avatarRow: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    marginTop: -40,
    width: '80%' as const,
  } as ViewStyle,
});
